import { createStyles } from "@material-ui/core";
import theme from "../../../theme/theme";

export const styles = createStyles({
  content: {
    marginLeft: 320
  },

  contentEmpty: {
    display: "flex",
    minHeight: "90vh",
    justifyContent: "center",
    alignItems: "center"
  },

  deviceGroupsInfoHeaderWrapper: {
    marginBottom: theme.spacing(4),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },

  devicesContainerHeaderWrapper: {
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(4),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },

  devicesListWrapper: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    paddingLeft: theme.spacing(2)
  },

  iconButtonWrapper: {
    alignItems: "center",
    position: "absolute",
    bottom: 0,
    right: 0
  },

  limitValuesListWrapper: {
    padding: theme.spacing(4),
    display: "flex",
    alignItems: "center",
    width: "100%"
  },

  logo: {
    height: "28px",
    width: "auto"
  },

  gridItem: {
    width: "100%"
  },

  limitRow: {
    width: "100%"
  },

  limitRowItem: {
    marginBottom: theme.spacing(4),
    "&:last-child": {
      marginBottom: 0
    },
    display: "flex",
    alignItems: "center",
    width: "100%"
  },

  limitRowItemButtonWrapper: {
    display: "flex",
    width: "10%",
    minWidth: "50px"
  },

  limitRowItemSelectWrapper: {
    display: "flex",
    width: "40%",
    marginRight: theme.spacing(1)
  },

  limitRowItemValueWrapper: {
    display: "flex",
    width: "25%",
    marginRight: theme.spacing(1)
  }
});